module.exports = __webpack_public_path__ + "img/Fond_Carte_Ulmo_XXL_Neutre.de6acc07.png";